import Fuse, { type IFuseOptions } from "fuse.js";
import { useMemo, useState } from "react";

export interface UseCollectionOptions<T> {
  data: T[];
  filter: IFuseOptions<T>;
}

export function useCollection<T>({ data, filter }: UseCollectionOptions<T>) {
  const [keyword, setKeyword] = useState("");

  const fuse = useMemo(() => {
    return new Fuse(data, {
      threshold: 0.3,
      ignoreLocation: true,
      includeScore: true,
      ...filter,
    });
  }, [data, filter]);

  const filteredData = useMemo(() => {
    if (!keyword) return data;
    const results = fuse.search(keyword);
    return results.map((result) => result.item);
  }, [data, keyword, fuse]);

  return {
    keyword,
    setKeyword,
    filteredData,
  };
}
